import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { ParentCard, PaginationButton, Pagination, HorizontalBar} from "./style";
import {
    Center,
    Box,
    Text,
    VStack,
    HStack,
} from '@chakra-ui/react';
import Select from "react-select";
import CardStatusPendaftaran from "../../components/CardStatusPendaftaran";
import APIConfig from "../../api/APIConfig";

import ReactLoading from "react-loading";

const StatusPendaftaran = (props) => {
    const [lowongan, setLowongan] = useState([]);
    const [peserta, setPeserta] = useState([]);
    const [mitra, setMitra] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const { id } = useParams();

    const [spinner, setSpinner] = useState(false);  

    const pageNumbers = [];
    let d = new Date().getDate();

    const optionKategori = [
        { value: 0, label: "-- Pilih Status --" },
        { value: 1, label: "Diterima" },
        { value: 2, label: "Ditolak" },
        { value: 3, label: "Menunggu Konfirmasi" },
    ]

    function publishDay(string){
        return new Date(string).getDate();
    }
      

    const getListProposal = async(idPeserta) => {
        setSpinner(true);
        const response = await APIConfig.get(`/v1/list-lowonganpeserta/peserta/${idPeserta}`);
        const result = await response.data
        setLowongan(result);
        setMitra(result);
        setPeserta(result.peserta);
        setSpinner(false);
    };

    const [selectedValue, setSelectedValue] = useState(0);

    const handleSearchKategori = (e) => {
        setSelectedValue(e.value);
    };

    const matcher = (data) => {
        console.log(selectedValue)

        if (selectedValue === 0) return true;
       else if (selectedValue === 1) {
            if (data.statusPenerimaan.includes("Diterima")) {
                return true;
            } 
            
        } else if (selectedValue === 2) {
            if (data.statusPenerimaan.includes("Ditolak")) {
                return true;
            }
        } else if (selectedValue === 3) {
            if (data.statusPenerimaan.includes("Menunggu Konfirmasi")) {
                return true
            };
        }
        return false;
    };
    let data = lowongan;

    data = data.filter((i) => matcher(i));
    console.log("test :" + data.length);

    for (let i = 1; i <= Math.ceil(data.length / 10); i++) {
        pageNumbers.push(i);
    }

    const indexOfLastData = currentPage * 10;
    const indexOfFirstData = indexOfLastData - 10;
    data = data.slice(indexOfFirstData, indexOfLastData);

    useEffect(() => {
        getListProposal(id);
    }, [])

    if (spinner) {
        return (
            <Center py={12}>
                <VStack align='stretch' fontFamily={'Inter'} pb={20}>
                <div className="section">
                    <div className="article">
                        <ReactLoading type="spin" color="#6554C0" />
                    </div>
                </div>
                </VStack>
            </Center>
              
        )
    }

    return (
        <Center py={6}>
            <VStack align='stretch' fontFamily={'Inter'} pb={20}>   
                <Text
                    pt={10}
                    color={'gray.700'}
                    fontWeight={600}
                    fontSize={'2xl'}>
                    List Lamaran
                </Text>
                <HStack color={'gray.500'} pb={10}>
                </HStack>
                <HStack pt={10} pr={10} justifyContent={"space-between"}>
                    <Select
                        borderRadius="0%"
                        fontSize='13px'
                        pt={3}
                        pb={3}
                        border='1px solid #F5F5F5'
                        width='10%'
                        height='40px' 
                        id='kategori' 
                        options={optionKategori}
                        onChange={handleSearchKategori}
                        value={optionKategori.find((obj) => obj.value === selectedValue)}
                        placeholder="Status Lamaran" />
                 </HStack>

                <Box pt={5} align='center'>
                    <ParentCard>
                        {data.length > 0 ? 
                            <div style={{display: 'flex', flexWrap:'wrap'}}>
                            {data.map((data) => (
                                <div style={{flex: '70%', padding:"6px", margin:"6px"}}>
                                        <CardStatusPendaftaran
                                            id={data.idLowonganPeserta}
                                            idPeserta={id}
                                            perusahaan={data.lowongan.mitra.namaResmi}
                                            kegiatan={data.lowongan.proposal.namaPosisi}
                                            aktivitas={`${d - publishDay(data.lowongan.waktuDipublish)} hari yang lalu`}
                                            logo={data.lowongan.mitra.image}
                                            status={data.statusPenerimaan}
                                            nominal={data.lowongan.proposal.nominal !== null && data.lowongan.proposal.nominal !== 0? `Rp${(data.lowongan.proposal.nominal+data.kodeUnik)}`: null}
                                            kodeUnik={data.kodeUnik !== null ? data.kodeUnik: null}
                                            pembayaran={data.lowongan.proposal.nominal !== null && data.lowongan.proposal.nominal !== 0 ? `Status pembayaran: ${(data.statusPembayaran)}`: null}
                                            />
                                </div>
                            ))}
                            </div>
                            : 
                            <Text fontSize={"large"} fontWeight={'600'}>Tidak ada lowongan</Text>
                        }
                        <Box alignContent={'center'}>
                        {data.length > 0 ? (<HorizontalBar last={true} />) : null}
                        {pageNumbers.length > 1 && (
                            <Pagination>
                                <PaginationButton onClick={() => 
                                    setCurrentPage(1)}>
                                    &lt;&lt;
                                </PaginationButton>
                                <PaginationButton onClick={() => 
                                    currentPage === 1 ? setCurrentPage(1) : setCurrentPage(currentPage-1)}>
                                    &lt;
                                </PaginationButton>
                                {pageNumbers.map((page) => (
                                    <PaginationButton
                                        unshow={
                                            currentPage > 2 && pageNumbers.length - currentPage > 1
                                            ? Math.abs(currentPage - page) > 2
                                            : pageNumbers.length - currentPage < 2
                                            ? pageNumbers.length - page > 4
                                            : page > 5
                                        }
                                        active={currentPage === page}
                                        onClick={() => setCurrentPage(page)}
                                        >
                                            {page}
                                    </PaginationButton>
                                ))}
                                <PaginationButton
                                    onClick={() =>
                                    currentPage === pageNumbers.length
                                        ? setCurrentPage(pageNumbers.length)
                                        : setCurrentPage(currentPage + 1)
                                    }
                                >
                                    &gt;
                                </PaginationButton>
                                <PaginationButton onClick={() => setCurrentPage(pageNumbers.length)}>
                                    &gt;&gt;
                                </PaginationButton>
                            </Pagination>
                            )}
                        </Box>
                    </ParentCard>
                </Box>
            </VStack>
        </Center>
    );
}

export default StatusPendaftaran;